import { render, staticRenderFns } from "./Consultantworkload.vue?vue&type=template&id=d1492c3c&scoped=true&"
import script from "./Consultantworkload.vue?vue&type=script&lang=js&"
export * from "./Consultantworkload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1492c3c",
  null
  
)

export default component.exports